import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {AlertController, IonSelect, NavController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {CompanyModel} from 'src/app/models/company.model';
import {UserModel} from 'src/app/models/user.model';
import {CompanyService} from 'src/app/services/company/company.service';
import {GlobalService} from 'src/app/services/global/global.service';
import {ApiResponse} from 'src/app/services/utils';

@Component({
    selector: 'app-company-employee',
    templateUrl: './company-employee.component.html',
    styleUrls: ['./company-employee.component.scss'],
    standalone: false
})
export class CompanyEmployeeComponent implements OnInit {
  @Input() item;
  @Input() company: CompanyModel;
  @Input() user: UserModel;
  @ViewChild('changeAdmin') changeAdmin: IonSelect;

  showUser = true;
  memberType = 'member';

  constructor(
    private navController: NavController,
    private globalService: GlobalService,
    public translate: TranslateService,
    private alertController: AlertController,
    private companyService: CompanyService
  ) {
  }

  ngOnInit() {
    if (this.item?.isAdmin) {
      this.memberType = 'admin';
    } else {
      this.memberType = 'member';
    }
  }

  openOtherProfile(id) {
    this.navController.navigateForward(['/app/profile/other-profile/' + id]);
  }

  changeTeamAdmin() {
    if (this.memberType === 'admin' && this.user.id !== this.item.id) {
      this.company.adminCount += 1;
      this.addCompanyAdmin();
    } else if (this.memberType === 'member') {
      if (this.company.adminCount > 1) {
        this.company.adminCount -= 1;
        this.removeTeamAdmin();
      } else {
        this.globalService.presentToast(this.translate.instant('lbl_at_least_one_admin'));
        this.changeAdmin.value = this.item.isAdmin ? 'admin' : 'member';
      }
    } else if (this.memberType === 'remove') {
      if (this.company.adminCount > 1 && this.item.isAdmin) {
        this.company.adminCount -= 1;
        this.removeTeamAdmin();
      } else if (!this.item.isAdmin) {
        this.deleteMember();
      } else {
        this.globalService.presentToast(this.translate.instant('lbl_at_least_one_admin'));
        this.changeAdmin.value = this.item.isAdmin ? 'admin' : 'member';
      }
    }
  }

  addCompanyAdmin() {
    const data = {
      companyId: this.company.id,
      userId: this.item.id
    };

    this.item.isAdmin = true;
    this.companyService.apiAddCompanyAdmin(data).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.memberType = 'admin';
        this.globalService.presentToast(result.message);
      }
    });
  }

  removeTeamAdmin() {
    const data = {
      companyId: this.company.id,
      userId: this.item.id
    };

    this.item.isAdmin = false;
    this.companyService.apiRemoveCompanyAdmin(data).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.memberType = 'member';
        this.globalService.presentToast(result.message);
      }
    });
  }

  async deleteMember() {
    const alert = await this.alertController.create({
      header: this.translate.instant('lbl_remove_employee'),
      cssClass: 'remove-action-point-alert',
      message: this.translate.instant('txt_do_you_really_want_to_remove_this_employee'),
      buttons: [
        {
          text: this.translate.instant('lbl_no'),
          role: 'cancel',
          cssClass: 'cancel-button',
          id: 'cancel-button',
          handler: () => {
            this.changeAdmin.value = this.item.isAdmin ? 'admin' : 'member';
          }
        },
        {
          text: this.translate.instant('lbl_yes'),
          id: 'confirm-button',
          cssClass: 'confirm-button',
          handler: () => {
            this.removeCompanyMember();
          }
        }
      ]
    });

    await alert.present();
  }

  removeCompanyMember() {
    const data = {
      companyId: this.company.id,
      userId: this.item.id
    };

    this.companyService.apiRemoveCompanyMember(data).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.showUser = false;
        this.globalService.presentToast(result.message);
      }
    });
  }
}
